import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Admin from "../views/Admin.vue";
import Maintainer from "../views/Maintainer.vue";
import store from "../store"
import AdminDashboard from "../navigations/admin/DashboardPanel.vue";
import AdminUserPanel from "../navigations/admin/UserPanel.vue"
import AdminRolePanel from "../navigations/admin/RolePanel.vue"
import MaintainerDashboard from "../navigations/maintainer/DashboardPanel.vue";
import FilePanel from "../navigations/maintainer/FilePanel"
import {ParseAuthService} from "../services"
import ArtistPanel from "../navigations/maintainer/ArtistPanel";
import AlbumPanel from "../navigations/maintainer/AlbumPanel";
import SongTypePanel from "../navigations/maintainer/SongTypePanel";
import SongPanel from "../navigations/maintainer/SongPanel";
import MediaPanel from "../navigations/maintainer/MediaPanel";
import ThumbnailPanel from "../navigations/maintainer/ThumbnailPanel";
import CdLinkPanel from "../navigations/maintainer/CdLinkPanel";
import CdLinkCategoryPanel from "../navigations/maintainer/CdLinkCategoryPanel";

Vue.use(VueRouter);

const routes = [
    {
        path: "",
        redirect: "login"
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        beforeEnter: (to, from, next) => {
            if (ParseAuthService.hasUser()) {
                return next({
                    name: store.getters['auth/hasMasterKey'] ? "Admin" : "Maintainer"
                });
            }
            next();
        }
    },
    {
        path: "/admin",
        component: Admin,
        children: [{
            path: "",
            name: "Admin",
            redirect: "dashboard"
        }, {
            path: "dashboard",
            name: "AdminDashboard",
            component: AdminDashboard
        }, {
            path: "role",
            name: "AdminRolePanel",
            component: AdminRolePanel
        }, {
            path: "user",
            name: "AdminUserPanel",
            component: AdminUserPanel
        }],
        beforeEnter: (to, from, next) => {
            if (!ParseAuthService.hasUser()) {
                return next({
                    name: 'Login'
                });
            } else if (!ParseAuthService.hasMasterKey()) {
                return next({
                    name: 'Maintainer'
                });
            }
            console.log(ParseAuthService.hasMasterKey())
            ParseAuthService.setMasterKey();
            next();
        },
    },
    {
        path: "/maintainer",
        component: Maintainer,
        children: [{
            path: "",
            name: "Maintainer",
            redirect: "dashboard"
        }, {
            path: "dashboard",
            name: "MaintainerDashboard",
            component: MaintainerDashboard
        }, {
            path: "file",
            name: "FilePanel",
            component: FilePanel
        }, {
            path: "artist",
            name: "ArtistPanel",
            component: ArtistPanel
        }, {
            path: "album",
            name: "AlbumPanel",
            component: AlbumPanel
        }, {
            path: "media",
            name: "MediaPanel",
            component: MediaPanel
        }, {
            path: "songType",
            name: "SongTypePanel",
            component: SongTypePanel
        }, {
            path: "thumbnail",
            name: "ThumbnailPanel",
            component: ThumbnailPanel
        }, {
            path: "cdLink",
            name: "CdLinkPanel",
            component: CdLinkPanel
        },{
            path: "cdLinkCategory",
            name: "CdLinkCategoryPanel",
            component: CdLinkCategoryPanel
        },{
            path: "song",
            name: "SongPanel",
            component: SongPanel
        },
        ],
        beforeEnter: (to, from, next) => {
            if (!ParseAuthService.hasUser()) {
                return next({
                    name: 'Login'
                });
            } else if (ParseAuthService.hasMasterKey()) {
                ParseAuthService.setMasterKey();
            }
            next();
        }
    }
    // {
    //   path: "/about",
    //   name: "About",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/About.vue")
    // }
];


const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

export default router;
